import { createContext, useContext } from 'react';
import type * as CookieConsent from 'vanilla-cookieconsent';

export interface CookieConsentContextType {
  cc: typeof CookieConsent | null;
}

export const CookieConsentContext = createContext<CookieConsentContextType>({
  cc: null,
});

//test commit

export const useCookieConsent = () => {
  const context = useContext(CookieConsentContext);
  if (!context) {
    throw new Error(
      'useCookieConsent must be used within a CookieConsentProvider',
    );
  }
  return context;
};
